import React, { useEffect, useState } from 'react';
import { Avatar, Layout, Menu, message } from 'antd';
import { Link } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import CurrentBalance from '../CurrentBalace';
import './styles.scss';
import Logout from '../Logout';
import { coreFetchSelectedCustomers, coreSetCurrentCustomer } from '../../Reducers/core';
import { getActiveCurrencyFromLS, getCurrentCustomerFromLS, setActiveCurrencyToLS } from '../../Services/CoreService'
import UserName from '../PrintUserName';
import IncreaseBalance from '../Balance/Increase';
import DecreaseBalance from '../Balance/Decrease';
import { UserOutlined } from '@ant-design/icons';
import CustomerSettingsModal from './CustomerSettingsModal';
// import { withRouter } from 'react-router';


const AntHeader = Layout.Header;

const currencyToProps = {
  "EUR": {
    "symbol": "€",
    "icon": "🇪🇺"
  },
  "USD": {
    "symbol": "$",
    "icon": "🇺🇸"
  }
}

function getLocation(pathname, exact = false) {
  if (exact) {
    return pathname;
  }

  if (pathname && pathname === '/') {
    return '/';
  }
  const arr = pathname.split('/');

  if (arr && arr.length >= 2 && arr[1] !== '') {
    return `/${arr[1]}`;
  }

  return pathname;
}

function Header({ location, isManager }) {
  const dispatch = useDispatch();

    const payload = useSelector(
    (state) => state.core.customer,
    shallowEqual
  );

  const customers = useSelector(
    (state) => state.core.customersSelected,
    shallowEqual
  );
  const nonManagerCustomerInit = useSelector(
    (state) => state.core.nonManagerCustomerInit,
    shallowEqual
  );

  // Логика перезаписи кастомера после изменений на бэкенде - работает при перезагрузке страницы

  const customersList = customers && customers?.payload

  const currentCustomer = getCurrentCustomerFromLS()

  const [customersListState, setCustomersListState] = useState([]);
  const [isLoading, setIsLoading] = useState(null);

  useEffect(() => {
    
    if (!customersList) {
      setIsLoading(true)
    } else {
      setCustomersListState(customersList)
      setIsLoading(false)
    }

  }, [customersList]);

  const [activeCurrency, setActiveCurrency] = useState(() => getActiveCurrencyFromLS());
  const isNonManagerCustomerReady = isManager || nonManagerCustomerInit.isInitialized;

  const handleChangeCurrency = (curr) => {
      setActiveCurrency(curr);
      setActiveCurrencyToLS(curr)
    }

  useEffect(() => {
    if (isManager && isLoading === false) {
      const findCurrentCustomer = customersListState.find((customer) => customer.id === currentCustomer.id)

      if (!findCurrentCustomer) {
        localStorage.setItem('__current_customer__', JSON.stringify(customersListState[0]));
      }
      if (currentCustomer && findCurrentCustomer) {
        const updatedCustomer = { ...currentCustomer };

        for (const key in updatedCustomer) {
          if (updatedCustomer[key] !== findCurrentCustomer[key] || !findCurrentCustomer) {
            updatedCustomer[key] = findCurrentCustomer[key];
          }
        }

        localStorage.setItem('__current_customer__', JSON.stringify(updatedCustomer));
      }
    }
  }, [currentCustomer, customersListState, isLoading, isManager]);

  // Конец логики автоматизированной перезаписи кастомера

  useEffect(() => {
    if (isManager) {
      dispatch(coreFetchSelectedCustomers())
        .catch((error) => {
          message.error(error.message || error);
        });
    }
  }, [dispatch, isManager]);

  
  useEffect(() => {
    const ensured = getActiveCurrencyFromLS();
    if (ensured !== activeCurrency) setActiveCurrency(ensured);
  }, [activeCurrency]);

  useEffect(() => {
    if (isManager) {
      dispatch(coreSetCurrentCustomer(getCurrentCustomerFromLS()));
    }
  }, [dispatch, isManager]);



  return (
    <AntHeader className="Header" >
      <Menu
        theme="dark"
        defaultSelectedKeys={[getLocation(location.pathname, true)]}
        selectedKeys={[getLocation(location.pathname, true)]}
        mode="horizontal"
        style={{ lineHeight: "64px", display: "flex", marginRight: "300px" }}
      >
        <Menu.Item key="/">
          <Link to="/">XBOX</Link>
        </Menu.Item>
        <Menu.Item key="/blizzard/price">
          <Link to="/blizzard/price">Blizzard</Link>
        </Menu.Item>
        <Menu.Item key="/orders">
          <Link to="/orders">Orders</Link>
        </Menu.Item>
        {isManager && <><Menu.Item key="/settings/general">
          <Link to="/settings/general">Settings</Link>
        </Menu.Item>
        <Menu.Item key="/settings/customer">
          <Link to="/settings/customer">Customer Settings</Link>
        </Menu.Item>
        <Menu.Item key="/managers/settings">
          <Link to="/managers/settings">Manager Settings</Link>
        </Menu.Item>
        <Menu.Item key="/balance">
        <Link to="/balance">Transactions</Link>
        </Menu.Item>
        </>
        }
        {!isManager && <Menu.Item key="/replenishments">
          <Link to="/replenishments">Transactions</Link>
        </Menu.Item>}
        
        {/* {isManager && 
        <>
        
        </>} */}
      </Menu>

      <div className="Header__rightBlock">
      {isManager ? 
        payload?.balances?.length > 0 ? 
        <div className="balances_wrapper">
          
        {payload.balances.map((bal) => 
        <div className={`balances_wrapper__info ${bal.cur === activeCurrency ? "active" : ""}`} onClick={() => handleChangeCurrency(bal.cur)}>
          
          {currencyToProps[bal.cur]["icon"]} Balance: <CurrentBalance balance={bal.balance} symbol={currencyToProps[bal.cur]["symbol"]}/> / Credit: <CurrentBalance balance={bal.creditLimit > 0 ? "-" + bal.creditLimit : bal.creditLimit} symbol={currencyToProps[bal.cur]["symbol"]}/>
         
          <div className='balances_wrapper__btns'>
              <IncreaseBalance id={payload.id} currency={bal.cur} />
              <DecreaseBalance id={payload.id} currency={bal.cur} />
              </div>
        </div>
       )}
       {/* </Link> */}
      </div> :
        <div className="balance_wrapper">
        
      <div className="balances_wrapper__info">
        {currencyToProps["EUR"]["icon"]} Balance: <CurrentBalance balance={payload.balance}/> / Credit: <CurrentBalance balance={payload.creditLimit > 0 ? "-" + payload.creditLimit : payload.creditLimit} />
       
      <div className='balance_wrapper__btns'>
          <IncreaseBalance id={payload.id} />
          <DecreaseBalance id={payload.id} />
          </div>
      </div>
     
    </div>  :
        isNonManagerCustomerReady ?
        payload?.balances?.length > 0 ? 
        <div className="balances_wrapper">
          
        {payload.balances.map((bal) => 
        <div className="balances_wrapper__info">
          {currencyToProps[bal.cur]["icon"]} Balance: <CurrentBalance balance={bal.balance} symbol={currencyToProps[bal.cur]["symbol"]}/> / Credit: <CurrentBalance balance={bal.creditLimit > 0 ? "-" + bal.creditLimit : bal.creditLimit} symbol={currencyToProps[bal.cur]["symbol"]}/>
          </div>)}
        </div> :
        
        <div className="balance_wrapper">
        
        <div className="balances_wrapper__info">
        {currencyToProps["EUR"]["icon"]} Balance: <CurrentBalance balance={payload.balance}/> / Credit: <CurrentBalance balance={payload.creditLimit > 0 ? "-" + payload.creditLimit : payload.creditLimit}/>
          </div>
          </div>
          : null
          }
      {/* <Avatar style={{ backgroundColor: 'rgb(131, 73, 246)' }} icon={<UserOutlined />} /> */}
      {isManager ? <CustomerSettingsModal /> : <Avatar style={{ backgroundColor: 'rgb(131, 73, 246)' }} icon={<UserOutlined />} /> }
      {isManager ? <UserName className=" Header__rightBlock__item" customers={customersList}/> : <span style={{color: 'white'}}>{isNonManagerCustomerReady ? payload.name : ''}</span>}
      
        <Logout />
      </div>
    </AntHeader>
  );
}

export default React.memo(Header);
